import {
  ImageWrapper,
  // Uncomment when the project icon is added to the bucket.
  // getMediaBasePath,
  pxToRem,
  pxTovW,
} from '@geneo2-web/shared-ui';
import { Box, Typography } from '@mui/material';
import { AssessmentContent } from '@protos/learning_management/lms.assessment.common.apis_pb';

const Heading = ({
  projectDetails,
  classSectionSubject,
  headingRightElement,
}: IProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: { xs: pxToRem(10), md: pxToRem(18), lg: pxTovW(20) },
        width: { xs: '100%', md: '70%' },
        alignItems: 'center',
      }}
    >
      <ImageWrapper
        name="create_project_icon"
        type="png"
        styles={styles.headingImage}
        parentFolder="icons"
        // Uncomment when the project icon is added to the bucket.
        // path={getMediaBasePath(
        //   projectDetails?.assessment?.assessmentPosterImgUrl,
        //   'processedMediaBucket'
        // )}
      />
      <Box
        sx={{
          display: 'flex',
          gap: { xs: pxToRem(5), md: pxToRem(5), lg: pxTovW(5) },
          flexDirection: 'column',
          width: { xs: '80%', md: '80%' },
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <Typography
            variant="h1"
            sx={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              wordWrap: 'break-word',
              fontWeight: 600
            }}
          >
            {projectDetails?.assessment?.assessmentTitle}
          </Typography>
          {headingRightElement}
        </Box>

        <Typography variant="h5" sx={{
          color: '#007CDC',
          fontSize: { xs: pxToRem(16), md: pxToRem(19), lg: pxTovW(21) },
          fontWeight: 400
        }}>
          {classSectionSubject}
        </Typography>
      </Box>
    </Box>
  );
};

export default Heading;

const styles = {
  headingImage: {
    width: { xs: pxToRem(60), md: pxToRem(69), lg: pxTovW(105) },
    height: { xs: pxToRem(60), md: pxToRem(69), lg: pxTovW(105) },
    borderRadius: { xs: pxToRem(10), md: pxToRem(10), lg: pxTovW(10) },
    objectFit: 'cover',
  },
};

interface IProps {
  projectDetails?: AssessmentContent;
  classSectionSubject?: string;
  headingRightElement?: React.ReactNode;
}
